import React from "react";
import Router from "./Router";

const Index = () => {
  return <Router />;
};

export default Index;
